module.exports = __webpack_public_path__ + "static/img/typebg2.712ae97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/typebg2.png
// module id = Yomw
// module chunks = 8